import { LessonProgressStatus } from '@onesource/schemas';
import { MdCheckCircle, MdPlayArrow, MdSchedule } from 'react-icons/md';

type ChipColor = 'primary' | 'success' | 'warning';
type ChipVariant = 'filled' | 'outlined';

export interface ProgressDisplay {
  icon: JSX.Element;
  label: string;
  color: ChipColor;
  variant: ChipVariant;
}

export const getProgressDisplay = (progress?: { status: LessonProgressStatus }): ProgressDisplay => {
  if (!progress) {
    return {
      icon: <MdPlayArrow size={16} />,
      label: 'Start',
      color: 'primary',
      variant: 'outlined',
    };
  }

  switch (progress.status) {
    case LessonProgressStatus.COMPLETED: {
      return {
        icon: <MdCheckCircle size={16} />,
        label: 'Completed',
        color: 'success',
        variant: 'filled',
      };
    }
    case LessonProgressStatus.IN_PROGRESS: {
      return {
        icon: <MdSchedule size={16} />,
        label: 'Continue',
        color: 'warning',
        variant: 'filled',
      };
    }
    default: {
      return {
        icon: <MdPlayArrow size={16} />,
        label: 'Start',
        color: 'primary',
        variant: 'outlined',
      };
    }
  }
};
